import React from "react";
import { Waves, Info } from "lucide-react";

export default function StreamsStep({ sources, connectedIds, streamOptions, choices, onChange, title = "Step 2 — Create Data Streams", description = "For each connected source, choose the correct object type to stream into Data Cloud as a Data Lake Object." }) {
  const connected = sources.filter((s) => connectedIds.includes(s.id));
  return (
    <div>
      <h3 className="font-heading font-semibold text-white mb-1">{title}</h3>
      <p className="text-sm text-slate-400 mb-4">{description}</p>
      <div className="space-y-3">
        {connected.map((s) => {
          const options = streamOptions[s.id];
          if (!options) {
            return (
              <div key={s.id} className="flex items-center gap-2 p-3 rounded-lg border border-amber-400/20 bg-amber-400/5 text-xs text-amber-300" data-testid={`streams-not-needed-${s.id}`}>
                <Info className="w-3.5 h-3.5 shrink-0" /> {s.name} isn't actually needed for this scenario — no stream required.
              </div>
            );
          }
          return (
            <div key={s.id} className="p-4 rounded-xl border border-white/10 bg-white/[0.02]" data-testid={`streams-source-${s.id}`}>
              <p className="text-sm font-medium text-white flex items-center gap-2 mb-3"><Waves className="w-4 h-4 text-indigo-400" /> {s.name}</p>
              <div className="flex flex-wrap gap-2">
                {options.map((opt) => (
                  <button
                    key={opt} onClick={() => onChange({ ...choices, [s.id]: opt })} data-testid={`streams-option-${s.id}-${opt.replace(/\s+/g, "-")}`}
                    className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${
                      choices[s.id] === opt ? "border-indigo-400 bg-indigo-400/10 text-indigo-300" : "border-white/10 text-slate-400 hover:border-white/25"
                    }`}
                  >
                    {opt}
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
